import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import Star from '@mui/icons-material/Star';
import Assignment from '@mui/icons-material/Assignment';
import MoreHoriz from '@mui/icons-material/MoreHoriz';
import PlayArrow from '@mui/icons-material/PlayArrow';
import Pause from '@mui/icons-material/Pause';
import { IconButton, Typography } from '@totalsoft/rocket-ui';
import ThinDivider from 'components/common/ThinDivider';
import { GridActionsWrapper } from 'components/common/CommonStyles';
import { useContext } from 'react';
import { RightsContext } from 'providers/RightsContext';

const timeFormat = totalMinutes => {
  const hours = Math.floor(totalMinutes / 60);
  var mins = totalMinutes % 60 < 10 ? `0${totalMinutes % 60}` : `${totalMinutes % 60}`;
  return `${hours}h ${mins}m`;
};

export const DocumentTasksListItemComponent = ({ task, userInfo, t, onOpenModal, onAssignToMe, onPauseTask, onStartTask }) => {
  const { assignFolderTaskRead, readOnlyFull, assignTaskRead } = useContext(RightsContext);

  return (
    <>
      <Grid item xs={12}>
        <Typography fontWeight='bold'> {task.name}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography>{t('TaskStatus.' + task.status.name)}</Typography>
      </Grid>
      <Grid item xs={6} textAlign='end'>
        <Typography>{timeFormat(task.workingMinutes)}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography>{t('TaskStatus.Generated')}</Typography>
      </Grid>
      <Grid item xs={6} textAlign='end'>
        <Typography>{t('DATE_FORMAT', { date: { value: task.createdAt, format: 'DD/MM/YYYY HH:mm' } })}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography>
          {task.isReplacementTask ? <Star /> : ''} {task.responsible && task.responsible.name}
        </Typography>
      </Grid>
      <GridActionsWrapper item container xs={6} justifyContent='end'>
        <IconButton
          color='warning'
          variant='text'
          size='tiny'
          tooltip={t('TaskList.Assign')}
          onClick={onOpenModal(task)}
          disabled={!task.canBeAssignedToOthers}
        >
          <MoreHoriz />
        </IconButton>
        {task.canBeAssignedToMe &&
          task.responsible?.id !== userInfo.userId &&
          !readOnlyFull &&
          (assignFolderTaskRead || assignTaskRead) && (
            <IconButton color='warning' variant='text' size='tiny' tooltip={t('TaskList.AssignToMe')} onClick={onAssignToMe(task)}>
              <Assignment />
            </IconButton>
          )}
        {task.canBeStarted && (
          <IconButton color='warning' variant='text' size='tiny' tooltip={t('TaskList.StartWork')} onClick={onStartTask(task)}>
            <PlayArrow />
          </IconButton>
        )}
        {task.canBePaused && (
          <IconButton color='warning' variant='text' size='tiny' tooltip={t('TaskList.PauseWork')} onClick={onPauseTask(task)}>
            <Pause />
          </IconButton>
        )}
      </GridActionsWrapper>
      <Grid item xs={12}>
        <ThinDivider />
      </Grid>
    </>
  );
};

DocumentTasksListItemComponent.propTypes = {
  task: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  onAssignToMe: PropTypes.func.isRequired,
  onPauseTask: PropTypes.func.isRequired,
  onStartTask: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired
};

export default compose(withTranslation())(DocumentTasksListItemComponent);
